import { useCallback, useEffect, useRef } from "react";
import { useGatheringContext, useGatheringStore } from "src/contexts/GatheringContext";
import usePageTitle from "src/hooks/usePageTitle";
import useRouter from "src/hooks/useRouter";

const SyncGatheringWebData = () => {
	const { store } = useGatheringContext();
	const name = useGatheringStore((state) => state.name);
	usePageTitle(name);

	const router = useRouter();
	const routerRef = useRef(router);
	useEffect(() => {
		routerRef.current = router;
	}, [router]);

	const refCode = useGatheringStore((state) => state.refCode);
	const refCodeRef = useRef(refCode);
	useEffect(() => {
		refCodeRef.current = refCode;
	}, [refCode]);

	const handleUpdateQueryParams = useCallback(() => {
		const searchParams = store.getState().getQueryParams();
		if (searchParams) {
			routerRef.current.replaceState(`/album/${refCodeRef.current}?${searchParams}`);
		} else {
			routerRef.current.replaceState(`/album/${refCodeRef.current}`);
		}
	}, [store]);

	useEffect(() => {
		const filterUserIdsSubscribe = store.subscribe(
			(state) => state.filterUserIds,
			() => {
				handleUpdateQueryParams();
			},
		);
		const filterUploaderIdsSubscribe = store.subscribe(
			(state) => state.filterUploaderIds,
			() => {
				handleUpdateQueryParams();
			},
		);
		const filterPhotoVariantSubscribe = store.subscribe(
			(state) => state.filterPhotoVariant,
			() => {
				handleUpdateQueryParams();
			},
		);
		const editModeSubscribe = store.subscribe(
			(state) => state.editMode,
			() => {
				handleUpdateQueryParams();
			},
		);
		const viewModeSubscribe = store.subscribe(
			(state) => state.viewMode,
			() => {
				handleUpdateQueryParams();
			},
		);
		const filterSubscribe = store.subscribe(
			(state) => state.filterMode,
			() => {
				handleUpdateQueryParams();
			},
		);
		const sortModeSubscribe = store.subscribe(
			(state) => state.sortMode,
			() => {
				handleUpdateQueryParams();
			},
		);
		const filterLabelsSubscribe = store.subscribe(
			(state) => state.filterLabels,
			() => {
				handleUpdateQueryParams();
			},
		);
		const filterRestrictedLabelsSubscribe = store.subscribe(
			(state) => state.filterRestrictedLabels,
			() => {
				handleUpdateQueryParams();
			},
		);
		const columnsSubscribe = store.subscribe(
			(state) => state.numColumnsTarget,
			() => {
				handleUpdateQueryParams();
			},
		);
		return () => {
			filterUserIdsSubscribe();
			filterUploaderIdsSubscribe();
			filterPhotoVariantSubscribe();
			editModeSubscribe();
			viewModeSubscribe();
			filterSubscribe();
			sortModeSubscribe();
			filterLabelsSubscribe();
			filterRestrictedLabelsSubscribe();
			columnsSubscribe();
		};
	}, [handleUpdateQueryParams, store]);

	return <></>;
};
export default SyncGatheringWebData;
